import EmptyData from './Empty'

export default EmptyData
